var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_547_951)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_547_951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 246,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.594 0.0408936H0V58.2777H245.594V0.0408936Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_547_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3821 14.2625C51.0966 9.63595 47.1461 6.11456 42.5632 6.40287C37.9805 6.69116 34.4924 10.6656 34.7781 15.2921C35.0637 19.9187 39.0141 23.4401 43.5968 23.1723C48.1796 22.8772 51.6677 18.889 51.3821 14.2625Z",
    fill: "#FF4B11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6861 29.1591H46.6574C46.6574 39.0918 38.6818 47.1436 28.8431 47.1436V58.2775C44.7809 58.2775 57.6861 45.2283 57.6861 29.1591Z",
    fill: "#FF4B11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.843 11.1542V0.0408936C12.9052 0.0408936 0 13.0694 0 29.1593H11.0286C11.0286 19.2061 19.0042 11.1542 28.843 11.1542Z",
    fill: "#FF4B11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8144 58.2765V40.2715C7.97568 40.2715 0 48.3233 0 58.2765H17.8144Z",
    fill: "#FF4B11"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5235f5592ec41a5b2f843f7e09ffc01a.svg";
export { ForwardRef as ReactComponent };